<template>
  <ModalBase v-if="isShowing()" modal-type="initial">
    <div slot="header">
      {{ $t("component.modal.updateAvailabilityModal.title") }}
    </div>
    <div slot="body">
      <div class="w-full">
        <div>
          <div class="m-1">
            <div class="relative">
              <datepicker
                v-model="to"
                input-class="block appearance-none bg-white border border-blue-200 text-gray-700 py-3 px-4 rounded leading-tight w-full"
                calendar-class="calendarPicker"
                :language="lang"
                :disabled-dates="{ to: heute }"
                :highlighted="highlighted"
                format="dd.MM.yyyy"
              ></datepicker>
              <div
                class="
                  cursor-pointer
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  text-gray-700
                "
              >
                <CalendarSVG />
              </div>
            </div>
            <label v-if="error !== ''" class="text-red-600 font-bold mt-4">
              {{ error }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button
        class="border mt-5 p-2 shadow text-gray-800 font-semibold"
        :class="[!to ? 'opacity-50 cursor-not-allowed' : '']"
        :disabled="!to === ''"
        @click="submit"
      >
        {{ $t("component.modal.updateAvailabilityModal.refresh") }}
      </button>
    </div>
  </ModalBase>
</template>

<script>
import ModalBase from "../shared/ModalBase";
import { mapGetters, mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import { de, pl, en } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import CalendarSVG from "../shared/svgs/CalendarSVG";
import UserService from "../../services/userOld.service";

export default {
  name: "UpdateAvailabilityModal",
  components: { CalendarSVG, ModalBase, Datepicker },
  data() {
    return {
      error: "",
      to: "",
      highlighted: {
        dates: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
        includeDisabled: true,
      },
    };
  },
  computed: {
    ...mapState("app", {
      alreadyUpdated: "alreadyUpdatedAvailability",
    }),
    ...mapGetters("app", {
      invitationId: "GET_INVITATION",
      isDialogVisible: "GET_SHOW_UPDATE_AVAILABILITY_DIALOG",
      needUpdate: "GET_NEEDS_AVAILABILITY_UPDATE",
      language: "GET_NEEDS_AVAILABILITY_UPDATE_LANGUAGE",
    }),

    heute() {
      let parsedDate = moment(new Date(), "YYYY-MM-DD").toDate();
      return parsedDate;
    },

    lang() {
      if (this.$i18n.locale === "de") {
        return de;
      } else if (this.$i18n.locale === "pl") {
        return pl;
      }

      return en;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch("app/getInvitationUid").then((uid) => {
        UserService.updateAvailability(uid, this.to.toISOString().slice(0, 10))
          .then(() => {
            this.$store.dispatch(
              "app/alreadyUpdatedAvailability",
              this.to.toISOString().slice(0, 10)
            );
            this.$router.push({ name: "app" }).catch(() => {});
          })
          .catch(() => {});
      });
    },

    isShowing() {
      let show = false;

      if (this.alreadyUpdated) {
        return false;
      }

      if (this.needUpdate !== null) {
        if (this.needUpdate === true) {
          show = true;
        }
      }
      return show;
    },
  },
};
</script>

<style>
.calendarPicker {
  width: 240px !important;
  left: 0px !important;
}
</style>
